<template>
  <div class="ask_advice">
    <div class="title">征求意见表</div>
    <div class="content">
      <el-form ref="askForm" :model="formData" :rules="rules" size="small" label-position="top" label-width="80px">
        <el-form-item label="客户名称：" prop="name">
          <el-input v-model="formData.name" placeholder="请输入客户名称"></el-input>
        </el-form-item>
        <el-form-item label="地址：" prop="address">
          <el-input v-model="formData.address" placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item label="被访人：" prop="Interviewee">
          <el-input v-model="formData.Interviewee" placeholder="请输入被访人"></el-input>
        </el-form-item>
        <el-form-item label="电话：" prop="mobile">
          <el-input v-model="formData.mobile" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="类别：" prop="type">
          <el-radio-group v-model="formData.type">
            <el-radio label="委托人员"></el-radio>
            <el-radio label="管理人员"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="问卷回访：" prop="huifang_type">
          <el-radio-group v-model="formData.huifang_type">
            <el-radio label="电话回访"></el-radio>
            <el-radio label="现场回访"></el-radio>
            <el-radio label="其他"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="问卷回访其他：" prop="huifang_typeQt" v-if="formData.huifang_type == '其他'">
          <el-input v-model="formData.huifang_typeQt" placeholder="请输入问卷回访其他"></el-input>
        </el-form-item>
        <el-form-item label="回访时间：" prop="huifang_time">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="formData.huifang_time"
            style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="委托/检测时间：" prop="weituo_time">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="formData.weituo_time"
            style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="回访内容：">
          <div class="text-box">
            <div class="text">&ensp;</div>
            <div class="text">1、委托流程及检测流程情况</div>
            <div class="text">2、违规违纪问题反馈</div>
            <div class="text">3、公司服务情况</div>
            <div class="text">4、其他需求</div>
          </div>
        </el-form-item>
        <el-form-item label="请您对我公司本次委托检测服务综合情况进行评价：10分" prop="weituo_zonghe">
          <el-radio-group v-model="formData.weituo_zonghe">
            <el-radio label="很满意(10)"></el-radio>
            <el-radio label="较满意(8)"></el-radio>
            <el-radio label="一般(6)"></el-radio>
            <el-radio label="不满意(0)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="请您对我公司检测人员的服务态度及言行行为进行评价：10分" prop="jianceren_fuwu">
          <el-radio-group class="radio-block" v-model="formData.jianceren_fuwu">
            <el-radio label="很好，热情、周到、耐心(10)"></el-radio>
            <el-radio label="较好，比较耐心(6)"></el-radio>
            <el-radio label="差，没有耐心、态度恶劣(0)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="我公司检测人员是否穿着工装：10分" prop="isgongzhuang">
          <el-radio-group v-model="formData.isgongzhuang">
            <el-radio label="穿着工装(10)"></el-radio>
            <el-radio label="未穿着工装(0)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="现场检查过程中是否存在敷衍了事的行为？(10分)" prop="jianceren_fuyan">
          <el-radio-group class="radio-block" v-model="formData.jianceren_fuyan">
            <el-radio label="存在敷衍了事行为(0)"></el-radio>
            <el-radio label="无敷衍了事行为(10)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="现场检测过程中检测人员的专业水平进行评价：10分" prop="jianceren_zhuanye">
          <el-radio-group class="radio-block" v-model="formData.jianceren_zhuanye">
            <el-radio label="员工专业水平高(10)"></el-radio>
            <el-radio label="员工专业水平低(0)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="现场检测过程中是否存在吃拿卡要或违规违纪的现象：10分" prop="weigui">
          <el-radio-group v-model="formData.weigui">
            <el-radio label="有(0)"></el-radio>
            <el-radio label="没有(10)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="您对我公司出具检测报告及时率的评价是：10分" prop="jishilv">
          <el-radio-group v-model="formData.jishilv">
            <el-radio label="好(10)"></el-radio>
            <el-radio label="一般(6)"></el-radio>
            <el-radio label="不够及时(0)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="请问您对我公司的检测质量和报告质量的评价：10分" prop="baogaozhiliang">
          <el-radio-group v-model="formData.baogaozhiliang">
            <el-radio label="满意(10)"></el-radio>
            <el-radio label="基本满意(6)"></el-radio>
            <el-radio label="不满意(0)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="请问您对于我公司的检测报告价格水平的评价：10分" prop="jiage">
          <el-radio-group v-model="formData.jiage">
            <el-radio label="价格略高(0)"></el-radio>
            <el-radio label="价格合理(10)"></el-radio>
            <el-radio label="价格较低(5)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="请问您对于我公司委托检测服务的响应速度满意度评价：10分" prop="xiangyingsudu">
          <el-radio-group v-model="formData.xiangyingsudu">
            <el-radio label="满意(10)"></el-radio>
            <el-radio label="较满意(6)"></el-radio>
            <el-radio label="不满意(0)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="请问您还有其他检测业务需要委托的么？我们会安排业务人员主动联系您：" prop="qitajiance">
          <el-radio-group v-model="formData.qitajiance">
            <el-radio label="没有"></el-radio>
            <el-radio label="有"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="意见和建议(您认为我公司在检测、服务哪些方面需改进或者有什么要求，请提出您的宝贵意见)：" prop="yijian">
          <el-input type="textarea" :autosize="true" v-model="formData.yijian" placeholder="请输入您的宝贵意见"></el-input>
        </el-form-item>
      </el-form>
      <div class="tips">非常感谢您的合作，如果您在委托中有什么问题，请随时和我们联系，我们将为您提供最好的服务。</div>
      <div class="line-title">工程信息</div>
      <div class="item-row">
        <div class="label">工程名称：</div>
        <div class="value">{{ proInfo.enginner_name }}</div>
      </div>
      <div class="item-row">
        <div class="label">监测项目：</div>
        <div class="value">{{ proInfo.test_item }}</div>
      </div>
      <div class="item-row">
        <div class="label">联&nbsp;&nbsp;系&nbsp;&nbsp;人：</div>
        <div class="value">{{ proInfo.customer }}</div>
      </div>
      <div class="item-row">
        <div class="label">联系电话：</div>
        <div class="value">{{ proInfo.customer_mobile }}</div>
      </div>
      <div class="item-row">
        <div class="label">所在地区：</div>
        <div class="value">{{ proInfo.province }} {{ proInfo.city }} {{ proInfo.area }}</div>
      </div>
      <div class="item-row">
        <div class="label">详细地址：</div>
        <div class="value">{{ proInfo.address }}</div>
      </div>
      <div class="item-row">
        <div class="label">业务经理：</div>
        <div class="value">{{ proInfo.business_name }}</div>
      </div>
      <!-- {{ formData }} -->
    </div>
    <div class="button-row">
      <el-button type="primary" size="small" @click="submitForm('askForm')">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ask_advice",
  data() {
    return {
      proInfo: {},
      formData: {
        taskid: 0,
        name: '',
        address: '',
        Interviewee: '',
        mobile: '',
        type: '',
        huifang_type: '',
        huifang_typeQt: '',
        huifang_time: '',
        weituo_time: '',
        weituo_zonghe: '',
        jianceren_fuwu: '',
        isgongzhuang: '',
        jianceren_zhuanye: '',
        jianceren_fuyan: '',
        weigui: '',
        jishilv: '',
        baogaozhiliang: '',
        jiage: '',
        xiangyingsudu: '',
        qitajiance: '',
        yijian: '',
      },
      rules: {
        name: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        Interviewee: [{ required: true, message: '请输入被访人', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类别', trigger: 'change' }],
        huifang_type: [{ required: true, message: '请选择问卷回访', trigger: 'change' }],
        huifang_typeQt: [{ required: true, message: '请输入其他问卷回访', trigger: 'blur' }],
        huifang_time: [{ required: true, message: '请选择回访时间', trigger: 'change' }],
        weituo_time: [{ required: true, message: '请选择委托/检测时间', trigger: 'change' }],
        weituo_zonghe: [{ required: true, message: '请您对我公司本次委托检测服务综合情况进行评价', trigger: 'change' }],
        jianceren_fuwu: [{ required: true, message: '请您对我公司检测人员的服务态度及言行行为进行评价', trigger: 'change' }],
        isgongzhuang: [{ required: true, message: '请您选择我公司检测人员是否穿着工装', trigger: 'change' }],
        jianceren_fuyan: [{ required: true, message: '请您对现场检测过程中检测人员的专业水平进行评价', trigger: 'change' }],
        jianceren_zhuanye: [{ required: true, message: '请您对现场检查过程中是否存在敷衍了事的行为进行评价', trigger: 'change' }],

        weigui: [{ required: true, message: '请您选择现场检测过程中是否存在吃拿卡要或违规违纪的现象', trigger: 'change' }],
        jishilv: [{ required: true, message: '您对我公司出具检测报告及时率进行评价', trigger: 'change' }],
        baogaozhiliang: [{ required: true, message: '请您对我公司的检测质量和报告质量进行评价', trigger: 'change' }],
        jiage: [{ required: true, message: '请您对于我公司的检测报告价格水平进行评价：', trigger: 'change' }],
        xiangyingsudu: [{ required: true, message: '请您对于我公司委托检测服务的响应速度满意度进行评价：', trigger: 'change' }],
        qitajiance: [{ required: true, message: '请您选择还有其他检测业务需要委托的么？', trigger: 'change' }],
        yijian: [{ required: true, message: '您认为我公司在检测、服务哪些方面需改进或有什么要求，请提出您的宝贵意见', trigger: 'blur' }],
      }
    };
  },
  mounted() {
    var id = this.$route.query.id;
    this.formData.taskid = id;
    this.showInfo();
  },
  methods: {
    async showInfo() {
      this.proInfo = await this.$api.request.get("/task/get_comment", {
        params: {
          taskid: this.formData.taskid,
        },
      });
    },
    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await that.$api.request.post("/task/submit_commentNew", that.formData);
          console.log(res, "res");
          that.$api.success("感谢您的评价！");
          that.$refs[formName].resetFields();
          that.showInfo();
        } else {
          return false;
        }
      })
    }
  }
}
</script>

<style scoped>
.title {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 15px;
  font-size: 18px;
  font-weight: 600;
  background: #ffffff;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content {
  padding: 15px;
  padding-top: 60px;
  padding-block: 72px;
}

.text-box {
  display: block;
  width: 100%;
}

.text-box .text {
  text-align: left;
}

.tips {
  margin-top: 40px;
  font-size: 14px;
  color: #999;
}

.line-title {
  font-size: 16px;
  background: #eee;
  text-align: left;
  line-height: 35px;
  padding-left: 15px;
  margin-top: 20px;
}

.item-row {
  display: flex;
  padding: 10px 0;
}

.item-row .label {
  width: 80px;
  font-size: 14px;
  line-height: 18px;
  color: #666;
}

.item-row .value {
  flex: 1;
  font-size: 14px;
  line-height: 18px;
  color: #333;
  text-align: left;
}

.button-row {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);
}

.el-form-item--small.el-form-item {
  margin-bottom: 26px;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
  line-height: 26px;
}

.el-radio-group {
  width: 100%;
  text-align: left;
}

.radio-block .el-radio {
  width: 100%;
  padding: 5px 0;
  margin-right: 0;
}

.button-row .el-button--primary {
  width: 100%;
}

.el-form-item__error {
  text-align: left;
  line-height: 14px;
}
</style>